import { usePromotion } from '@mc/promo-utils'
import { useGiftEnabled } from '../../../lib/helpers'

export const useIsEligible = () => {
  const { isPromotionOn } = usePromotion()
  const { giftEnabled } = useGiftEnabled()

  return isPromotionOn && giftEnabled
}
